import { LeadViewEntry } from '../board/leads-views';

/**
 * The Roll-off Hires view registry.
 *
 * The same shape and the same switcher the Leads collection uses - that
 * component already takes its entries as an input, so what varies between the
 * two collections is this list and nothing else. Writing a second segmented
 * control beside it would be the parallel file tree the README names.
 *
 * Table and Board are routes, so the URL completely identifies which
 * presentation is on screen: a link to a hire's list is a link somebody can
 * send. There is no Analysis entry - roll-off has no analysis page yet, and the
 * switcher renders only entries whose route is actually registered, so adding
 * one later is adding a route and a line here.
 */
export const ROLLOFF_VIEWS: LeadViewEntry[] = [
  { id: 'list',  label: 'Table', icon: 'table_rows',  route: '/rolloff-hires/table' },
  { id: 'board', label: 'Board', icon: 'view_kanban', route: '/rolloff-hires/board' },
];
